export const UnidadesProdutividade = {
    ARROBAS: 'ARROBAS',
    SACAS: 'SACAS',
    TONELADAS: 'TONELADAS'
};
